import { Product } from '@acorn-portal/shared/src/services/api';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';

const REMOTE_BASE_PATHS: Partial<Record<Product, string>> = {
	[Product.HOUSEHOLD]: '/portal/hh',
};

export const getPolicyRoute = (product: Product, policyToken: string, policyNumber: string): string => {
	const remotePath = REMOTE_BASE_PATHS[product];

	if (remotePath) {
		return `${remotePath}/policy-details/${policyToken}`;
	}

	const encodedPolicyNumber = encodeURIComponent(policyNumber);
	return `${ROUTE_PATHS.policyDetails}/${policyToken}?policyNumber=${encodedPolicyNumber}`;
};
